(() => {
  if (window.__athenaClubInit) {
    return;
  }
  window.__athenaClubInit = true;

  const initMegaMenu = () => {
    const header = document.querySelector("[data-athena-header]");
    if (!header) return;

    const isHome = header.dataset.isHome === "true" || !!document.querySelector("[data-athena-home-hero]");
    const mega = header.querySelector("[data-athena-mega]");
    const triggers = Array.from(header.querySelectorAll("[data-menu-trigger]"));
    const closeTargets = Array.from(header.querySelectorAll("[data-menu-close]"));
    const views = Array.from(header.querySelectorAll("[data-mega-view]"));
    const shopAllTriggers = Array.from(header.querySelectorAll("[data-shopall-category-trigger]"));
    const shopAllPanels = Array.from(header.querySelectorAll("[data-shopall-panel]"));
    const mobilePrimaryTriggers = Array.from(header.querySelectorAll("[data-mobile-primary-trigger]"));
    const mobileViews = Array.from(header.querySelectorAll("[data-mobile-view]"));
    const mobileShopAllTriggers = Array.from(header.querySelectorAll("[data-mobile-shopall-trigger]"));
    const mobileShopAllPanels = Array.from(header.querySelectorAll("[data-mobile-shopall-panel]"));
    let closeTimer = null;

    const syncHeaderTheme = () => {
      const overlay = isHome && window.scrollY <= 12;
      const megaOpen = header.dataset.megaOpen === "true";
      const drawerOpen = header.dataset.drawerOpen === "true";
      header.dataset.headerTheme = overlay && !megaOpen && !drawerOpen ? "overlay" : "solid";
    };

    const randomizeHeaderTracks = () => {
      header.querySelectorAll("[data-header-randomize]").forEach((track) => {
        if (track.dataset.randomized === "true") return;

        const cards = Array.from(track.querySelectorAll("[data-header-product-card]"));
        if (!cards.length) return;

        const maxCards = Number.parseInt(track.dataset.maxCards || "", 10);
        const limit = Number.isFinite(maxCards) && maxCards > 0 ? maxCards : cards.length;
        const shuffledCards = shuffleItems([...cards]);
        const fragment = document.createDocumentFragment();

        shuffledCards.forEach((card, index) => {
          card.classList.toggle("is-hidden", index >= limit);
          fragment.appendChild(card);
        });

        track.replaceChildren(fragment);
        track.dataset.randomized = "true";
      });
    };

    const setActiveView = (viewKey) => {
      views.forEach((view) => {
        view.classList.toggle("is-active", view.dataset.megaView === viewKey);
      });

      triggers.forEach((trigger) => {
        trigger.classList.toggle("is-active", trigger.dataset.menuTrigger === viewKey);
      });
    };

    const setActiveShopAllCategory = (category) => {
      shopAllTriggers.forEach((item) => {
        item.classList.toggle("is-active", item.dataset.shopallCategoryTrigger === category);
      });

      shopAllPanels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.shopallPanel === category);
      });
    };

    const setActiveMobileView = (viewKey) => {
      mobilePrimaryTriggers.forEach((trigger) => {
        trigger.classList.toggle("is-active", trigger.dataset.mobilePrimaryTrigger === viewKey);
      });

      mobileViews.forEach((view) => {
        view.classList.toggle("is-active", view.dataset.mobileView === viewKey);
      });
    };

    const setActiveMobileShopAllCategory = (category) => {
      mobileShopAllTriggers.forEach((trigger) => {
        trigger.classList.toggle("is-active", trigger.dataset.mobileShopallTrigger === category);
      });

      mobileShopAllPanels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.mobileShopallPanel === category);
      });
    };

    const cancelClose = () => {
      clearTimeout(closeTimer);
    };

    const openMega = (viewKey) => {
      if (window.matchMedia("(max-width: 979px)").matches) return;
      if (!viewKey) return;

      cancelClose();
      setActiveView(viewKey);
      header.dataset.megaOpen = "true";
      syncHeaderTheme();
      mega?.classList.add("is-open");
    };

    const closeMegaNow = () => {
      cancelClose();
      header.dataset.megaOpen = "false";
      syncHeaderTheme();
      mega?.classList.remove("is-open");
      triggers.forEach((trigger) => trigger.classList.remove("is-active"));
    };

    const scheduleClose = () => {
      closeTimer = window.setTimeout(() => {
        closeMegaNow();
      }, 120);
    };

    randomizeHeaderTracks();

    const firstShopAllCategory = shopAllTriggers[0]?.dataset.shopallCategoryTrigger;
    if (firstShopAllCategory) {
      setActiveShopAllCategory(firstShopAllCategory);
    }

    const firstMobileView = mobilePrimaryTriggers[0]?.dataset.mobilePrimaryTrigger;
    if (firstMobileView) {
      setActiveMobileView(firstMobileView);
    }

    const firstMobileShopAllCategory = mobileShopAllTriggers[0]?.dataset.mobileShopallTrigger;
    if (firstMobileShopAllCategory) {
      setActiveMobileShopAllCategory(firstMobileShopAllCategory);
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () => {
        openMega(trigger.dataset.menuTrigger);
      });
      trigger.addEventListener("focus", () => {
        openMega(trigger.dataset.menuTrigger);
      });
    });

    closeTargets.forEach((target) => {
      target.addEventListener("mouseenter", closeMegaNow);
      target.addEventListener("focus", closeMegaNow);
    });

    mega?.addEventListener("mouseenter", cancelClose);
    mega?.addEventListener("mouseleave", scheduleClose);
    header.addEventListener("mouseleave", scheduleClose);

    shopAllTriggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () => {
        setActiveShopAllCategory(trigger.dataset.shopallCategoryTrigger);
      });
      trigger.addEventListener("focusin", () => {
        setActiveShopAllCategory(trigger.dataset.shopallCategoryTrigger);
      });
    });

    const mobileToggle = header.querySelector("[data-mobile-menu-toggle]");
    const mobileDrawer = header.querySelector("[data-mobile-drawer]");
    const closeMobileDrawer = () => {
      if (!mobileToggle || !mobileDrawer) return;
      mobileToggle.setAttribute("aria-expanded", "false");
      mobileDrawer.hidden = true;
      header.dataset.drawerOpen = "false";
      document.body.classList.remove("athena-mobile-menu-open");
      syncHeaderTheme();
    };

    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener("click", () => {
        const expanded = mobileToggle.getAttribute("aria-expanded") === "true";
        mobileToggle.setAttribute("aria-expanded", expanded ? "false" : "true");
        mobileDrawer.hidden = expanded;
        header.dataset.drawerOpen = expanded ? "false" : "true";
        if (expanded) {
          document.body.classList.remove("athena-mobile-menu-open");
        } else {
          closeMegaNow();
          document.body.classList.add("athena-mobile-menu-open");
        }
        syncHeaderTheme();
      });
    }

    mobilePrimaryTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setActiveMobileView(trigger.dataset.mobilePrimaryTrigger);
      });
    });

    mobileShopAllTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setActiveMobileShopAllCategory(trigger.dataset.mobileShopallTrigger);
      });
    });

    document.addEventListener("click", (event) => {
      if (!header.contains(event.target)) {
        closeMegaNow();
      }
    });

    window.addEventListener("resize", () => {
      if (window.matchMedia("(max-width: 979px)").matches) {
        closeMegaNow();
      } else {
        closeMobileDrawer();
      }
      syncHeaderTheme();
    });

    header.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeMegaNow();
        closeMobileDrawer();
      }
    });

    syncHeaderTheme();
    if (isHome) {
      window.addEventListener("scroll", syncHeaderTheme, { passive: true });
      window.addEventListener("resize", syncHeaderTheme);
    }
  };

  const initCartDrawer = () => {
    if (window.__athenaCartDrawerInit) return;
    window.__athenaCartDrawerInit = true;

    const cartSectionId = "athena-cart-drawer";
    let drawerBootPromise = null;

    const getHeader = () => document.querySelector("[data-athena-header]");
    const getDrawer = () => document.querySelector("[data-athena-cart-drawer]");

    const syncHeaderTheme = (open) => {
      const header = getHeader();
      if (!header) return;

      header.dataset.drawerOpen = open ? "true" : "false";

      const isHome = header.dataset.isHome === "true" || !!document.querySelector("[data-athena-home-hero]");
      const overlay = isHome && window.scrollY <= 12;
      const megaOpen = header.dataset.megaOpen === "true";
      header.dataset.headerTheme = overlay && !megaOpen && !open ? "overlay" : "solid";
    };

    const updateHeaderCount = (count) => {
      document.querySelectorAll("[data-athena-cart-count]").forEach((node) => {
        node.textContent = count > 0 ? ` (${count})` : "";
      });

      document
        .querySelectorAll("[data-athena-header] a[href='/cart'], [data-athena-header] a[href$='/cart']")
        .forEach((node) => {
          if (node.querySelector("[data-athena-cart-count]")) return;

          const baseLabel =
            node.dataset.cartBaseLabel ||
            node.textContent.replace(/\s*\(\d+\)\s*$/, "").trim() ||
            "Cart";

          node.dataset.cartBaseLabel = baseLabel;
          node.textContent = count > 0 ? `${baseLabel} (${count})` : baseLabel;
        });
    };

    const setStatus = (message) => {
      const drawer = getDrawer();
      const status = drawer?.querySelector("[data-athena-cart-status]");
      if (!status) return;
      status.textContent = message || "";
    };

    const setBusy = (busy) => {
      const drawer = getDrawer();
      if (!drawer) return;
      drawer.dataset.cartBusy = busy ? "true" : "false";
    };

    const replaceDrawerMarkup = (html) => {
      const drawer = getDrawer();
      if (!drawer || !html) return;

      const doc = new DOMParser().parseFromString(html, "text/html");
      const nextDrawer = doc.querySelector("[data-athena-cart-drawer]");
      if (!nextDrawer) return;

      drawer.setAttribute("data-cart-count", nextDrawer.getAttribute("data-cart-count") || "0");
      drawer.innerHTML = nextDrawer.innerHTML;
      updateHeaderCount(Number(drawer.getAttribute("data-cart-count") || "0"));
    };

    const buildDrawerSectionUrl = () => {
      const sectionUrl = new URL(window.location.href);
      if (!sectionUrl.pathname || sectionUrl.pathname === "/cart") {
        sectionUrl.pathname = "/";
      }
      sectionUrl.searchParams.delete("cart_drawer");
      sectionUrl.searchParams.set("section_id", cartSectionId);
      return `${sectionUrl.pathname}${sectionUrl.search}${sectionUrl.hash}`;
    };

    const mountDrawer = (html) => {
      if (!html) return null;

      const doc = new DOMParser().parseFromString(html, "text/html");
      const sectionWrapper = doc.querySelector("#shopify-section-athena-cart-drawer");
      const drawer = doc.querySelector("[data-athena-cart-drawer]");

      if (!drawer) return null;
      if (getDrawer()) return getDrawer();

      if (sectionWrapper) {
        document.body.appendChild(sectionWrapper);
      } else {
        document.body.appendChild(drawer);
      }

      return getDrawer();
    };

    const closeCompetingDialogs = () => {
      document.querySelectorAll("dialog[open]").forEach((dialog) => {
        if (dialog === getDrawer()) return;
        if (typeof dialog.close === "function") {
          dialog.close();
        } else {
          dialog.removeAttribute("open");
        }
      });
    };

    const bindDrawerEvents = (drawer) => {
      if (!drawer || drawer.dataset.drawerBound === "true") return;
      drawer.dataset.drawerBound = "true";

      drawer.addEventListener("close", () => {
        document.body.classList.remove("athena-cart-open");
        syncHeaderTheme(false);
      });

      drawer.addEventListener("cancel", (event) => {
        event.preventDefault();
        closeDrawer();
      });

      drawer.addEventListener("click", async (event) => {
        const activeDrawer = getDrawer();
        if (!activeDrawer) return;

        const closeTrigger = event.target.closest("[data-athena-cart-close], [data-athena-cart-continue]");
        if (closeTrigger) {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (event.target === activeDrawer) {
          closeDrawer();
          return;
        }

        const removeTrigger = event.target.closest("[data-athena-cart-remove]");
        if (removeTrigger && activeDrawer.dataset.cartBusy !== "true") {
          event.preventDefault();
          setBusy(true);
          setStatus("");

          try {
            const payload = await requestCart("/cart/change.js", {
              line: Number(removeTrigger.dataset.line),
              quantity: 0,
              sections: cartSectionId,
              sections_url: `${window.location.pathname}${window.location.search}`,
            });
            replaceDrawerMarkup(payload.sections?.[cartSectionId] || "");
            setStatus("Cart updated.");
            await openDrawer();
          } catch (error) {
            setStatus(error.message || "Could not update cart.");
          } finally {
            setBusy(false);
          }

          return;
        }

        const quantityTrigger = event.target.closest("[data-athena-cart-quantity]");
        if (quantityTrigger && activeDrawer.dataset.cartBusy !== "true") {
          event.preventDefault();

          const currentQuantity = Number(quantityTrigger.dataset.quantity || "0");
          const delta = Number(quantityTrigger.dataset.delta || "0");
          const nextQuantity = currentQuantity + delta;
          if (nextQuantity < 1) return;

          setBusy(true);
          setStatus("");

          try {
            const payload = await requestCart("/cart/change.js", {
              line: Number(quantityTrigger.dataset.line),
              quantity: nextQuantity,
              sections: cartSectionId,
              sections_url: `${window.location.pathname}${window.location.search}`,
            });
            replaceDrawerMarkup(payload.sections?.[cartSectionId] || "");
            setStatus("Cart updated.");
            await openDrawer();
          } catch (error) {
            setStatus(error.message || "Could not update cart.");
          } finally {
            setBusy(false);
          }
        }
      });
    };

    const ensureDrawer = async () => {
      const existingDrawer = getDrawer();
      if (existingDrawer) {
        bindDrawerEvents(existingDrawer);
        return existingDrawer;
      }

      if (!drawerBootPromise) {
        drawerBootPromise = fetch(buildDrawerSectionUrl(), {
          credentials: "same-origin",
          headers: {
            Accept: "text/html",
          },
        })
          .then((response) => response.text())
          .then((html) => {
            const mountedDrawer = mountDrawer(html);
            if (!mountedDrawer) {
              throw new Error("Could not load cart drawer.");
            }
            bindDrawerEvents(mountedDrawer);
            return mountedDrawer;
          })
          .finally(() => {
            drawerBootPromise = null;
          });
      }

      return drawerBootPromise;
    };

    const openDrawer = async () => {
      const drawer = await ensureDrawer();
      if (!drawer) return;

      if (!drawer.open) {
        closeCompetingDialogs();
        if (typeof drawer.showModal === "function") {
          drawer.showModal();
        } else {
          drawer.setAttribute("open", "open");
        }
      }

      document.body.classList.add("athena-cart-open");
      syncHeaderTheme(true);
    };

    const closeDrawer = () => {
      const drawer = getDrawer();
      if (!drawer) return;

      if (drawer.open && typeof drawer.close === "function") {
        drawer.close();
      } else {
        drawer.removeAttribute("open");
      }

      document.body.classList.remove("athena-cart-open");
      syncHeaderTheme(false);
    };

    const requestCart = async (endpoint, payload, useFormData = false) => {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: useFormData
          ? {
              Accept: "application/json",
            }
          : {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
        body: useFormData ? payload : JSON.stringify(payload),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || "Could not update cart.");
      }

      return data;
    };

    const consumeOpenQuery = async () => {
      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.get("cart_drawer") !== "open") return;

      await ensureDrawer();
      currentUrl.searchParams.delete("cart_drawer");
      const nextUrl =
        currentUrl.pathname +
        (currentUrl.searchParams.toString() ? `?${currentUrl.searchParams.toString()}` : "") +
        currentUrl.hash;

      await openDrawer();
      window.history.replaceState({}, "", nextUrl || "/");
    };

    const initialDrawer = getDrawer();
    if (initialDrawer) {
      bindDrawerEvents(initialDrawer);
    }

    document.addEventListener("click", async (event) => {
      const cartToggle = event.target.closest(
        "[data-athena-cart-toggle], [data-athena-header] a[href='/cart'], [data-athena-header] a[href$='/cart']"
      );
      if (!cartToggle) return;
      event.preventDefault();
      setStatus("");
      await openDrawer();
    });

    document.addEventListener(
      "submit",
      async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const action = form.getAttribute("action") || "";
        const submitter = event.submitter;
        const isProductAddForm =
          action.includes("/cart/add") ||
          form.matches("[data-role='family-form']") ||
          form.matches("[data-role='spotlight-form']") ||
          Boolean(form.closest(".athena-product__atc")) ||
          Boolean(form.querySelector("input[name='id']"));

        if (!isProductAddForm || form.closest("[data-athena-cart-drawer]")) return;
        if (submitter?.closest(".shopify-payment-button")) return;
        if (submitter?.hasAttribute("formnovalidate")) return;

        const activeDrawer = await ensureDrawer();
        if (activeDrawer.dataset.cartBusy === "true") {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        setBusy(true);
        setStatus("");

        try {
          const formData = new FormData(form);
          formData.set("sections", cartSectionId);
          formData.set("sections_url", `${window.location.pathname}${window.location.search}`);

          const payload = await requestCart("/cart/add.js", formData, true);
          replaceDrawerMarkup(payload.sections?.[cartSectionId] || "");
          setStatus("Added to cart.");
          await openDrawer();
        } catch (error) {
          setStatus(error.message || "Could not add this item.");
          await openDrawer();
        } finally {
          setBusy(false);
        }
      },
      true
    );

    if (initialDrawer) {
      updateHeaderCount(Number(initialDrawer.getAttribute("data-cart-count") || "0"));
    }
    consumeOpenQuery();
  };

  const updateCard = (card, source) => {
    const image = card.querySelector("[data-role='family-image']");
    const link = card.querySelector("[data-role='family-link']");
    const hover = card.querySelector("[data-role='family-hover']");
    const variant = card.querySelector("[data-role='family-variant']");
    const price = card.querySelector("[data-role='family-price']");
    const compare = card.querySelector("[data-role='family-compare']");
    const formInput = card.querySelector("[data-role='family-variant-id']");
    const form = card.querySelector("[data-role='family-form']");
    const button = card.querySelector("[data-role='family-submit']");
    const buttonPrice = card.querySelector("[data-role='family-button-price']");

    if (image && source.dataset.image) image.src = source.dataset.image;
    if (image && source.dataset.imageAlt) image.alt = source.dataset.imageAlt;
    if (link && source.dataset.url) link.href = source.dataset.url;
    if (hover) {
      hover.style.backgroundImage = source.dataset.hover
        ? `url("${source.dataset.hover}")`
        : "";
    }
    if (variant) {
      variant.textContent = source.dataset.variant || "";
      variant.hidden = !source.dataset.variant;
    }
    if (price) price.textContent = source.dataset.price || "";
    if (compare) {
      compare.textContent = source.dataset.compare || "";
      compare.hidden = !source.dataset.compare;
    }
    if (formInput && source.dataset.variantId) {
      formInput.value = source.dataset.variantId;
    }
    if (form && source.dataset.variantId) {
      form.dataset.productid = source.dataset.variantId;
    }
    if (buttonPrice) buttonPrice.textContent = source.dataset.price || "";
    if (button) {
      const unavailable = source.dataset.available === "false";
      button.disabled = unavailable;
      button.querySelector("[data-role='family-button-text']").textContent = unavailable
        ? "Sold Out"
        : "Buy Now";
    }
  };

  const initFamilyCards = () => {
    document.querySelectorAll("[data-athena-family-card]").forEach((card) => {
      const options = card.querySelectorAll("[data-family-select]");
      if (!options.length) return;

      options.forEach((option) => {
        option.addEventListener("click", () => {
          options.forEach((item) => item.classList.remove("is-active"));
          option.classList.add("is-active");
          updateCard(card, option);
        });
      });
    });
  };

  const initSpotlight = () => {
    document.querySelectorAll("[data-athena-spotlight]").forEach((section) => {
      const slides = Array.from(section.querySelectorAll("[data-spotlight-slide]"));
      const dots = Array.from(section.querySelectorAll("[data-spotlight-dot]"));
      if (!slides.length || !dots.length) return;

      const setActive = (index) => {
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle("is-active", slideIndex === index);
        });
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle("is-active", dotIndex === index);
        });
      };

      let activeIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
      if (activeIndex < 0) activeIndex = 0;
      setActive(activeIndex);

      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => setActive(index));
      });
    });
  };

  const initQuoteCarousel = () => {
    document.querySelectorAll("[data-athena-quote-carousel]").forEach((section) => {
      const slides = Array.from(section.querySelectorAll("[data-quote-slide]"));
      const logos = Array.from(section.querySelectorAll("[data-quote-logo]"));
      if (!slides.length || !logos.length || slides.length !== logos.length) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
      if (activeIndex < 0) activeIndex = 0;
      let timer = null;

      const setActive = (index) => {
        activeIndex = index;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });

        logos.forEach((logo, logoIndex) => {
          const isActive = logoIndex === index;
          logo.classList.toggle("is-active", isActive);
          logo.setAttribute("aria-current", isActive ? "true" : "false");
        });
      };

      const startTimer = () => {
        if (timer) window.clearInterval(timer);
        if (slides.length < 2) return;
        timer = window.setInterval(() => {
          const nextIndex = (activeIndex + 1) % slides.length;
          setActive(nextIndex);
        }, 5000);
      };

      logos.forEach((logo, index) => {
        logo.addEventListener("click", () => {
          setActive(index);
          startTimer();
        });
      });

      setActive(activeIndex);
      startTimer();
    });
  };

  const initProofCarousel = () => {
    document.querySelectorAll("[data-athena-proof]").forEach((section) => {
      const track = section.querySelector("[data-proof-track]");
      const slides = Array.from(section.querySelectorAll("[data-proof-slide]"));
      const reviews = Array.from(section.querySelectorAll("[data-proof-review]"));
      const prev = section.querySelector("[data-proof-prev]");
      const next = section.querySelector("[data-proof-next]");
      if (!track || !slides.length || slides.length !== reviews.length) return;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
      if (activeIndex < 0) activeIndex = 0;

      let timer = null;
      let scrollTick = null;
      let isDragging = false;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let suppressClick = false;

      const normalizeIndex = (index) => {
        if (!slides.length) return 0;
        return (index + slides.length) % slides.length;
      };

      const setActiveState = (index) => {
        activeIndex = normalizeIndex(index);

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-current", isActive ? "true" : "false");
        });

        reviews.forEach((review, reviewIndex) => {
          const isActive = reviewIndex === activeIndex;
          review.classList.toggle("is-active", isActive);
          review.setAttribute("aria-hidden", isActive ? "false" : "true");
        });
      };

      const scrollToActive = (behavior = "smooth") => {
        const activeSlide = slides[activeIndex];
        if (!activeSlide) return;

        const trackRect = track.getBoundingClientRect();
        const slideRect = activeSlide.getBoundingClientRect();
        const slideCenter = track.scrollLeft + (slideRect.left - trackRect.left) + slideRect.width / 2;
        const targetLeft = slideCenter - track.clientWidth / 2;
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        const nextLeft = Math.min(maxScrollLeft, Math.max(0, targetLeft));

        if (Math.abs(track.scrollLeft - nextLeft) < 1) return;

        if (typeof track.scrollTo === "function") {
          track.scrollTo({
            left: nextLeft,
            behavior,
          });
          return;
        }

        track.scrollLeft = nextLeft;
      };

      const restartTimer = () => {
        if (timer) window.clearInterval(timer);
        if (slides.length < 2) return;
        timer = window.setInterval(() => {
          setActiveState(activeIndex + 1);
          scrollToActive("smooth");
        }, 5000);
      };

      const activate = (index, behavior = "smooth") => {
        setActiveState(index);
        scrollToActive(behavior);
        restartTimer();
      };

      const closestIndex = () => {
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let bestIndex = activeIndex;
        let bestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, slideIndex) => {
          const rect = slide.getBoundingClientRect();
          const slideCenter = rect.left + rect.width / 2;
          const distance = Math.abs(center - slideCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = slideIndex;
          }
        });

        return bestIndex;
      };

      const syncFromScroll = () => {
        if (scrollTick) window.cancelAnimationFrame(scrollTick);
        scrollTick = window.requestAnimationFrame(() => {
          scrollTick = null;
          const nextIndex = closestIndex();
          if (nextIndex !== activeIndex) {
            setActiveState(nextIndex);
          }
        });
      };

      const stopDragging = () => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove("is-dragging");
        if (dragPointerId !== null && track.hasPointerCapture?.(dragPointerId)) {
          track.releasePointerCapture(dragPointerId);
        }
        dragPointerId = null;
        const nextIndex = closestIndex();
        activate(nextIndex, "smooth");
      };

      track.addEventListener("scroll", syncFromScroll, { passive: true });

      track.addEventListener("pointerdown", (event) => {
        if (event.button !== undefined && event.button !== 0) return;
        isDragging = true;
        suppressClick = false;
        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add("is-dragging");
        track.setPointerCapture?.(event.pointerId);
        if (timer) window.clearInterval(timer);
      });

      track.addEventListener("pointermove", (event) => {
        if (!isDragging) return;
        const delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 6) suppressClick = true;
        track.scrollLeft = dragStartScroll - delta;
      });

      track.addEventListener("pointerup", stopDragging);
      track.addEventListener("pointercancel", stopDragging);
      track.addEventListener("lostpointercapture", stopDragging);

      track.addEventListener(
        "click",
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        },
        true
      );

      prev?.addEventListener("click", () => activate(activeIndex - 1));
      next?.addEventListener("click", () => activate(activeIndex + 1));

      section.addEventListener("mouseenter", () => {
        if (timer) window.clearInterval(timer);
      });
      section.addEventListener("mouseleave", restartTimer);
      section.addEventListener("focusin", () => {
        if (timer) window.clearInterval(timer);
      });
      section.addEventListener("focusout", restartTimer);

      window.addEventListener("resize", () => {
        window.requestAnimationFrame(() => scrollToActive("auto"));
      });

      setActiveState(activeIndex);
      scrollToActive("auto");
      restartTimer();
    });
  };

  const shuffleItems = (items) => {
    for (let index = items.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[swapIndex]] = [items[swapIndex], items[index]];
    }

    return items;
  };

  const randomizeMixedRail = (track) => {
    if (track.dataset.railMode !== "mixed") return;

    const order = (track.dataset.railOrder || "")
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean);
    const maxProducts = Number.parseInt(track.dataset.railMax || "", 10);
    const cards = Array.from(track.querySelectorAll("[data-athena-family-card]"));
    if (!order.length || !cards.length) return;

    const groupedCards = new Map();
    cards.forEach((card) => {
      const category = card.dataset.familyCategory || "default";
      if (!groupedCards.has(category)) groupedCards.set(category, []);
      groupedCards.get(category).push(card);
    });

    if (track.dataset.railRandomize !== "false") {
      groupedCards.forEach((group) => shuffleItems(group));
    }

    const targetCount = Number.isFinite(maxProducts) && maxProducts > 0 ? maxProducts : cards.length;
    const selectedCards = [];

    while (selectedCards.length < targetCount) {
      let addedInCycle = false;

      order.forEach((category) => {
        const group = groupedCards.get(category);
        if (!group || !group.length || selectedCards.length >= targetCount) return;
        selectedCards.push(group.shift());
        addedInCycle = true;
      });

      if (!addedInCycle) break;
    }

    if (selectedCards.length < targetCount) {
      groupedCards.forEach((group) => {
        while (group.length && selectedCards.length < targetCount) {
          selectedCards.push(group.shift());
        }
      });
    }

    if (!selectedCards.length) return;

    const fragment = document.createDocumentFragment();
    selectedCards.forEach((card) => fragment.appendChild(card));
    track.replaceChildren(fragment);
  };

  const initRails = () => {
    document.querySelectorAll("[data-athena-rail]").forEach((rail) => {
      const track = rail.querySelector("[data-athena-rail-track]");
      const prev = rail.querySelector("[data-athena-rail-prev]");
      const next = rail.querySelector("[data-athena-rail-next]");
      if (!track) return;

      randomizeMixedRail(track);

      const amount = () => {
        const card = track.querySelector("[data-athena-family-card]");
        const styles = window.getComputedStyle(track);
        const gapValue = styles.columnGap || styles.gap || "0";
        const gap = Number.parseFloat(gapValue) || 0;
        if (!card) return Math.min(track.clientWidth * 0.92, 420);
        return card.getBoundingClientRect().width + gap;
      };

      prev?.addEventListener("click", () => {
        track.scrollBy({ left: -amount(), behavior: "smooth" });
      });
      next?.addEventListener("click", () => {
        track.scrollBy({ left: amount(), behavior: "smooth" });
      });
    });
  };

  const initCollectionFilters = () => {
    document.querySelectorAll(".athena-collection-main").forEach((scope) => {
      const drawer = scope.querySelector("[data-athena-filter-drawer]");
      const open = scope.querySelector("[data-athena-filter-toggle]");
      const close = scope.querySelector("[data-athena-filter-close]");
      if (!drawer || !open) return;

      const setOpen = (value) => {
        drawer.hidden = !value;
        open.setAttribute("aria-expanded", value ? "true" : "false");
      };

      open.addEventListener("click", () => {
        const expanded = open.getAttribute("aria-expanded") === "true";
        setOpen(!expanded);
      });

      close?.addEventListener("click", () => setOpen(false));
    });
  };

  const setMainImage = (scope, trigger) => {
    const image = scope.querySelector("[data-product-main-image]");
    if (!image) return;
    if (trigger.dataset.image) image.src = trigger.dataset.image;
    if (trigger.dataset.alt) image.alt = trigger.dataset.alt;
  };

  const initProductGallery = () => {
    document.querySelectorAll("[data-athena-product]").forEach((scope) => {
      const thumbs = scope.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          thumbs.forEach((item) => item.classList.remove("is-active"));
          thumb.classList.add("is-active");
          setMainImage(scope, thumb);
        });
      });

      const swatches = scope.querySelectorAll("[data-product-variant]");
      const variantInput = scope.querySelector("[data-product-variant-id]");
      const currentPrice = scope.querySelector("[data-product-price]");
      const comparePrice = scope.querySelector("[data-product-compare]");
      const selected = scope.querySelector("[data-product-selected]");
      const submit = scope.querySelector("[data-product-submit]");
      const submitLabel = scope.querySelector("[data-product-submit-label]");
      const submitSep = scope.querySelector("[data-product-submit-sep]");
      const submitPrice = scope.querySelector("[data-product-submit-price]");

      swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          swatches.forEach((item) => item.classList.remove("is-active"));
          swatch.classList.add("is-active");
          if (variantInput) variantInput.value = swatch.dataset.variantId || "";
          if (currentPrice) currentPrice.textContent = swatch.dataset.price || "";
          if (comparePrice) {
            comparePrice.textContent = swatch.dataset.compare || "";
            comparePrice.hidden = !swatch.dataset.compare;
          }
          if (selected) {
            selected.textContent = swatch.dataset.label || "";
            selected.hidden = !swatch.dataset.label;
          }
          if (submit) {
            const unavailable = swatch.dataset.available === "false";
            submit.disabled = unavailable;
            if (submitLabel) submitLabel.textContent = unavailable ? "Sold Out" : "Add to Cart";
            if (submitSep) submitSep.hidden = unavailable;
            if (submitPrice) {
              submitPrice.hidden = unavailable;
              submitPrice.textContent = swatch.dataset.price || "";
            }
          }
          setMainImage(scope, swatch);
        });
      });
    });
  };

  const initCadenceCards = () => {
    document.querySelectorAll("[data-athena-cadence-group]").forEach((group) => {
      const cards = group.querySelectorAll("[data-athena-cadence-card]");
      cards.forEach((card) => {
        card.addEventListener("click", () => {
          cards.forEach((item) => item.classList.remove("is-active"));
          card.classList.add("is-active");
        });
      });
    });
  };

  const initFaq = () => {
    document.querySelectorAll("[data-athena-faq]").forEach((scope) => {
      const items = scope.querySelectorAll(".athena-faq__item");
      items.forEach((item) => {
        const toggle = item.querySelector("[data-accordion-toggle]");
        toggle?.addEventListener("click", () => {
          const open = item.classList.contains("is-open");
          items.forEach((row) => {
            row.classList.remove("is-open");
            row.querySelector("[data-accordion-toggle]")?.setAttribute("aria-expanded", "false");
          });
          if (!open) {
            item.classList.add("is-open");
            toggle.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  };

  const initClubSignupButton = () => {
    document.querySelectorAll("[data-athena-club-signup] .athena-club-signup__submit").forEach((button) => {
      button.style.padding = "0";
      button.style.border = "0";
      button.style.borderRadius = "999px";
      button.style.background = "transparent";
      button.style.boxShadow = "none";
      button.style.cursor = "pointer";
      button.style.appearance = "none";
      button.style.webkitAppearance = "none";
    });
  };

  const init = () => {
    initMegaMenu();
    initCartDrawer();
    initFamilyCards();
    initSpotlight();
    initQuoteCarousel();
    initProofCarousel();
    initRails();
    initCollectionFilters();
    initProductGallery();
    initCadenceCards();
    initFaq();
    initClubSignupButton();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
